"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSkillLevelFromXP = calculateSkillLevelFromXP;
exports.calculateSkillXPRequiredForLevel = calculateSkillXPRequiredForLevel;
exports.percentCompleteSkill = percentCompleteSkill;
exports.calcSkillLevelForCharacter = calcSkillLevelForCharacter;
exports.assessPercentToNextSkill = assessPercentToNextSkill;
const SKILL_COEFFICIENT = 1.55;
function calculateSkillLevelFromXP(skillXP) {
    const skillValue = skillXP ?? 0;
    if (skillValue < 100)
        return 0;
    const value = Math.log((skillValue - 1) / 100) / Math.log(SKILL_COEFFICIENT); // -1 because for some reason level 1 displays as 2, fuck math or something?
    return 1 + Math.floor(value);
}
function calculateSkillXPRequiredForLevel(level) {
    if (level === 0)
        return 100;
    return Math.floor(Math.pow(SKILL_COEFFICIENT, level) * 100);
}
function percentCompleteSkill(player, skill) {
    const skillValue = player.skills[skill] || 0;
    const skillLevel = calculateSkillLevelFromXP(skillValue);
    const nextLevel = skillLevel === 0 ? 100 : calculateSkillXPRequiredForLevel(skillLevel);
    const prevLevel = skillLevel === 0 ? 0 : calculateSkillXPRequiredForLevel(skillLevel - 1);
    const normalizedCurrent = skillValue - prevLevel;
    const normalizedMax = nextLevel - prevLevel;
    const percentWay = Math.max(0, (normalizedCurrent / normalizedMax) * 100).toFixed(3);
    return percentWay;
}
function calcSkillLevelForCharacter(character, skill) {
    if (!skill) {
        throw new Error('Trying to calculate skill of undefined');
    }
    const skillValue = character.skills[skill.toLowerCase()] ?? 0;
    return calculateSkillLevelFromXP(skillValue);
}
function assessPercentToNextSkill(character, skill) {
    const skillValue = character.skills[skill] ?? 0;
    const skillLevel = calcSkillLevelForCharacter(character, skill);
    const nextLevel = skillLevel === 0 ? 100 : calculateSkillXPRequiredForLevel(skillLevel);
    const prevLevel = skillLevel === 0 ? 0 : calculateSkillXPRequiredForLevel(skillLevel - 1);
    const normalizedCurrent = skillValue - prevLevel;
    const normalizedMax = nextLevel - prevLevel;
    const percentWay = Math.min(99.999, Math.max(0, (normalizedCurrent / normalizedMax) * 100)).toFixed(3);
    return percentWay;
}
